module.exports = __webpack_public_path__ + "img/keyboard-help.ba8d2c91.jpg";